import React from 'react';
import { Outlet, Link, useLocation } from 'react-router-dom';
import Footer from './Footer';
import ThemeToggle from './ThemeToggle';

function PageWithHeader() {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-primary-light dark:bg-primary-dark text-text-light dark:text-text-dark">
      <header className="flex justify-between items-center py-4 px-6 bg-white dark:bg-gray-900 border-b border-gray-200 dark:border-gray-700 w-full">
        <div className="flex items-center">
          <Link to="/" className="text-gray-900 dark:text-white font-medium flex items-center">
            <span className="bg-orange-500 w-4 h-4 mr-2 rounded" />
            Shenqian Wen
          </Link>
        </div>

        <div className="flex items-center space-x-4">
          <nav className="flex space-x-4">
            <Link
              to="/"
              className={`text-sm ${location.pathname === '/' ? 'text-gray-900 dark:text-white' : 'text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white'}`}
            >
              Home
            </Link>
            <Link
              to="/about"
              className={`text-sm ${location.pathname === '/about' ? 'text-gray-900 dark:text-white' : 'text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white'}`}
            >
              About Me
            </Link>
            
            <Link
              to="/projects"
              className={`text-sm ${location.pathname === '/projects' ? 'text-gray-900 dark:text-white' : 'text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white'}`}
            >
              Projects
            </Link>
            <Link
              to="/fun"
              className={`text-sm ${location.pathname === '/fun' ? 'text-gray-900 dark:text-white' : 'text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white'}`}
            >
              Fun
            </Link>
            {/* <Link
              to="/notes"
              className={`text-sm ${location.pathname === '/notes' ? 'text-gray-900' : 'text-gray-600 hover:text-gray-900'}`}
            >
              Notes
            </Link> */}

          </nav>
          <ThemeToggle />
        </div>
      </header>

      <main className="container mx-auto py-8 px-4">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}

export default PageWithHeader;